import { View, ActivityIndicator } from 'react-native';
import { useTheme } from '../src/theme/ThemeContext';
import { useThemedStyles } from '../src/theme/useThemedStyles';
import type { Theme } from '../src/theme/types';

/**
 * Root index screen.
 *
 * Navigation is handled centrally by the root _layout.tsx useEffect which
 * redirects to (auth), (setup), or (tabs) based on auth + encryption state.
 * This screen only renders briefly while that redirect fires; it must NOT
 * issue its own <Redirect> or router.replace() calls to avoid double-
 * navigation race conditions with the layout guard.
 */
export default function Index() {
  const styles = useThemedStyles(createStyles);
  const { colors } = useTheme();

  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" color={colors.primary} accessibilityLabel="Loading application" />
    </View>
  );
}

const createStyles = (theme: Theme) => ({
  container: {
    flex: 1,
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    backgroundColor: theme.colors.bgSecondary,
  },
});
